import React, { useEffect, useRef } from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'
import Form from 'react-bootstrap/Form'

//Components
import { SearchIcon, CloseIcon } from 'components/SASIcon'

//Styles
import styles from './Search.module.scss'

//Hooks
import { useIsSmallDevice } from 'hooks'

interface Props {
  onSubmit: () => void,
  query: string,
  onChange: (value: string) => void
}

const Search = ({onSubmit, query, onChange}:Props) => {
  const isSmallDevice = useIsSmallDevice()
  const { t } = useTranslation()
  const input = useRef<HTMLInputElement>(null)

  const submit = (e:React.FormEvent) => {
    e.preventDefault()
    e.stopPropagation()
    
    onSubmit()
  }

  useEffect(()=>{
    input.current?.focus()
  },[])

  return (
    <>
      <form className={styles.search} onSubmit={submit}>
        <Form.Control 
          className={`${styles.input} ${isSmallDevice ? styles.mobile : ''}`} 
          placeholder={t('helpcenter-gui-icu.search.placeholder.label')} 
          value={query}
          onChange={e => onChange(e.target.value)}
          type="text"
          aria-label={t('helpcenter-gui-icu.search.aria')}
          title={t('helpcenter-gui-icu.search.title')}
          ref={input}
        />
        <div className={styles.actions}>
          {
            query &&
            <button 
              className={styles.clear} 
              type="button"
              title={t('helpcenter-gui-icu.search.clear.button.label')}
              arial-label={t('helpcenter-gui-icu.search.clear.button.label')}
              onClick={e => onChange("")}
              data-testid="clear-btn">
              <CloseIcon />
            </button>
          }
          <button 
            className={styles.submit} 
            type="submit" 
            title={t('helpcenter-gui-icu.search.submit.button.label')}
            aria-label={t('helpcenter-gui-icu.search.submit.button.label')}
            data-testid="search-btn">
            <SearchIcon />
          </button>
        </div>
      </form>
    </>
  )
}

export default Search